import React from 'react';
export function Footer() {
  return <footer className="bg-gray-950 text-gray-400 py-8 px-4 border-t border-gray-800" data-id="element-52">
      <div className="max-w-4xl mx-auto text-center" data-id="element-53">
        <p className="text-sm" data-id="element-54">
          PRODUCTO DIGITAL · Acceso inmediato · Descarga en PDF
        </p>
        <p className="text-sm mt-2" data-id="element-55">
          © 2024 Sistema Ciclista 360. Todos los derechos reservados
        </p>
      </div>
    </footer>;
}